// extracted by mini-css-extract-plugin
export default {"container":"PublicTopicPosts-module__container--qRq4A","animatedBackground":"PublicTopicPosts-module__animatedBackground--KdWcY"};